module.exports = __webpack_public_path__ + "media/images/google-play@2x-1fba640918182802701343f86ee62482.webp";